module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3W5nE4/tc-custom/9781449400187.jpg?1705766127459",
      "alt": "This image is the cover for the book Cider Beans, Wild Greens, and Dandelion Jelly"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cider Beans, Wild Greens, and Dandelion Jelly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Down-home and delicious recipes from southern Appalachia, plus photos and tidbits on the region’s history and culture.")]), _c('br'), _c('br'), _vm._v("There are many cookbooks about Southern cooking, but precious few celebrate the southern Appalachian food that has sustained mountain folk past and present. Thankfully, we now have Joan E. Aller’s "), _c('i', [_vm._v("Cider Beans, Wild Greens, and Dandelion Jelly")]), _vm._v("."), _c('br'), _c('br'), _vm._v("Featuring more than 150 recipes for down-home, soul-satisfying dishes, this is more than just a cookbook. Complete with passages on the history, places, and people of southern Appalachia, along with lush full-color photography of the food and scenery of the southern Appalachian Mountains, "), _c('i', [_vm._v("Cider Beans, Wild Greens, and Dandelion Jelly")]), _vm._v(" serves as both a cookbook and a guided tour of the local lore, traditions, and culture of this uniquely American region. "), _c('br'), _c('br'), _vm._v("“For all foodies and lovers of hearty food that feeds both body and soul, Joan Aller unearths a mother lode of southern Appalachian sustenance.” —"), _c('i', [_vm._v("Appalachian News")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joan E. Aller\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0